import styles from "./modal.module.scss";
import * as React from "react";
import { v4 as uuidv4 } from "uuid";
import { ButtonBox, ButtonWrap } from "../../button/Button";

interface IModalButton {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  theme?: string;
  size?: string;
  action: () => void;
}
interface IModal {
  modalId?: string;
  isShow: boolean;
  title?: string;
  overlay?: boolean;
  overlayValue?: number;
  overlayStyle?: React.CSSProperties;
  theme?: "brown500";
  text?: string;
  buttons?: IModalButton[];
  onClose?: () => void;
  zIndex?: number;
  className?: string;
}
const Modal = ({
  modalId,
  isShow,
  overlay = false,
  overlayValue = 0.08,
  overlayStyle,
  theme,
  title,
  text,
  buttons,
  onClose,
  zIndex,
  className,
}: IModal) => {
  const uuid = uuidv4();

  const prevClassCheck = className ? className.includes("modal-wrap") : false;

  return (
    <div
      className={`${styles["modal-wrap"]} ${className ? className : ""}`}
      style={{ display: isShow ? "block" : "none" }}
    >
      {overlay && (
        <div
          className={`${styles["modal-overlay"]} ${prevClassCheck ? "modal-overlay" : ""}`}
          style={{
            backgroundColor: `rgba(0, 0, 0, ${overlayValue})`,
            ...overlayStyle,
          }}
        ></div>
      )}
      <div
        className={`${styles["modal"]} ${prevClassCheck ? "modal" : ""}`}
        style={{
          zIndex: zIndex ? zIndex : "",
        }}
      >
        <div
          className={`${styles["modal-content-box"]} ${title && text ? styles["exists-title-and-text"] : ""} 
          ${prevClassCheck ? "modal-content-box" : ""} ${prevClassCheck && title && text ? "exists-title-and-text" : ""}`}
        >
          <h2 className={`${styles["modal-title"]} ${prevClassCheck ? "modal-title" : ""}`}>
            {title}
          </h2>
          <p className={`${styles["modal-text"]} ${prevClassCheck ? "modal-text" : ""}`}>{text}</p>
        </div>

        {buttons ? (
          <ButtonWrap
            firstRatio={buttons.length >= 2 ? 1 : null}
            noPaddingPosition="all"
            className={`${styles["modal-btn-wrap"]} ${prevClassCheck ? "modal-btn-wrap" : ""}`}
          >
            {buttons.map((button) => (
              <ButtonBox
                key={`${modalId ? modalId : uuid}-${button.name}`}
                text={button.name}
                style={button.style ? button.style : {}}
                size={button.size ? button.size : "giant"}
                theme={button.theme ? button.theme : "red500"}
                fullWidth={buttons.length === 1}
                className={`${button?.className ? button.className : ""} ${prevClassCheck ? "btn" : ""}`}
                onClick={() => button.action()}
              />
            ))}
          </ButtonWrap>
        ) : (
          <ButtonWrap
            noPaddingPosition="all"
            className={`${styles["modal-btn-wrap"]} ${prevClassCheck ? "modal-btn-wrap" : ""}`}
          >
            <ButtonBox
              text="확인"
              size="giant"
              theme={theme ? theme : "red500"}
              fullWidth
              onClick={onClose}
              className={`${prevClassCheck ? "btn" : ""}`}
            />
          </ButtonWrap>
        )}
      </div>
    </div>
  );
};

export default Modal;
